import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import ApiClient from "../services/api-client"
import { AgGridReact } from 'ag-grid-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom'
import { isMobile } from "react-device-detect";
import useStore from "../hooks/useStore";

const AllFieldsRenderer = forwardRef((props, ref) => {
    const { t } = useTranslation();

    useImperativeHandle(ref, () => {
        return {
            refresh(params) {

            }
        };
    });

    return (

        <div className="customer-grid-row">

            <div className="d-flex bd-highlight allFieldsColumnRow">
                <div className="p-0 bd-highlight">
                    <span >
                        {props.data ? props.data.name + " " : ""}
                    </span>
                </div>
            </div>


            <div className="d-flex bd-highlight allFieldsColumnRow">
                <div className="p-0 bd-highlight">
                    <i className="fa fa-envelope"></i>
                    {

                        props.data && props.data.contacts && props.data.contacts.length > 0 && props.data.contacts[0].email ? <span style={{ marginRight: 6 }}>
                            <a href={"mailto:" + props.data.contacts[0].email}> <span style={{ marginLeft: 4 }}></span>
                                <span>
                                    {props.data.contacts[0].email}
                                </span>
                            </a>
                        </span> : <></>
                    }
                    {
                        props.data && props.data.taxpayerId ? <> <span >{t("taxpayerId")}: </span><span style={{ marginRight: 6 }}>{props.data.taxpayerId}</span></> : <></>
                    }

                </div>
            </div>


            <div className="d-flex bd-highlight allFieldsColumnRow">
                <div className="p-0 flex-grow-1 bd-highlight">
                    <i className="fa fa-phone"></i>
                    {
                        props.data && props.data.contacts && props.data.contacts.length && props.data.contacts[0].phone ? <span>
                            <a href={"tel:+ " + props.data.contacts[0].phone}>  <span style={{ marginRight: 6 }}></span>
                                {props.data.contacts[0].phone}
                            </a>
                        </span> : <></>
                    }
                </div>
            </div>
        </div >
    );
});


const ActionsRenderer = forwardRef((props, ref) => {


    const navigate = useNavigate();
    const { t } = useTranslation();

    const goToAddCustomer = (e) => {
        e.preventDefault();
        var _id = props.data.id;
        navigate("/customer/" + _id);
    }
    const goToSendInvoice = (e) => {
        e.preventDefault();
        var _id = props.data.id;
        var _url = "/sale?customer=" + _id
        window.open(_url, '_blank').focus();
    }
    useImperativeHandle(ref, () => {
        return {
            refresh(params) {

            }
        };
    });
    const getclass = () => {
        return !isMobile ? "btn-group" : "btn-group-vertical"
    }
    return (
        <span>
            <div className={getclass()} role="group">
                <button onClick={goToSendInvoice} className="btn btn-sm btn-skin" title={t("sendInvoiceToCustomer")}><i className="fa fa-paper-plane"></i></button>
                <button onClick={goToAddCustomer} className="btn btn-sm btn-skin" title={t("editCustomer")}><i className="fa fa-edit"></i></button>
            </div>
        </span>
        // <span className="editableCell">{branch != null && branch.label != undefined ? branch.label : <span className="addtext"></span>}</span>
    );
});

export default function CustomerSearch() {

    const [content, setContent] = useState([]);
    const navigate = useNavigate();
    const [gridApi, setGridApi] = useState(null);
    const { t } = useTranslation();
    const pagination = true;
    const paginationPageSize = 20;
    const [sheight, setSheight] = useState(window.innerHeight - 180);
    // const detectMobile = useMobileDetect();


    const onGridReady = params => {
        setGridApi(params.api);
        
        window.addEventListener('resize', function () {
            setTimeout(function () {
                setSheight(window.innerHeight - 180);
            }, 300);
        });
    };
    const onQuickFilterChanged = e => {
        gridApi.setQuickFilter(e.target.value);
    };
    const goTo = id => {
        navigate("/customer/" + id);
    }

    useEffect(() => {

        var companyId= useStore.getState().selectedCompany.id;

        ApiClient.getCompanyCustomers(companyId).then(
            response => {
                setContent(response.data);

            },
            error => {
                setContent(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString())
            }
        );

    }, []);

    const [columnDefs] = useState([
        { field: "name", flex: 2, minWidth: 300, headerName: t("Name"), sortable: true, filter: "agTextColumnFilter" },
        { field: "taxpayerId", flex: 1, minWidth: 150, headerName: t("taxpayerId"), sortable: true, filter: "agNumberColumnFilter" },
        { field: "taxOffice.name", flex: 2, minWidth: 250, headerName: t("taxOffice"), sortable: true, filter: "agTextColumnFilter" },
        { field: "balance", flex: 1, minWidth: 100, headerName: t("Balance"), sortable: true, filter: "agTextColumnFilter", valueFormatter: function (params) { return params.data != null ? (params.data.balance ? params.data.balance.toFixed(2) : 0.00) : 0.00 } },
        { field: "action", flex: 1, minWidth: 100, headerName: t("Actions"), cellRenderer: ActionsRenderer }
    ]);

    const [columnMobileDefs] = useState([
        { field: "name", flex: 5, headerName: t(""), cellRenderer: AllFieldsRenderer },
        { field: "action", flex: 1, headerName: t("Actions"), cellRenderer: ActionsRenderer }
    ]);
    return (
        <div className="container" style={{ padding: 0 }}>

            <header className="jumbotron search_header">
                <div className="d-flex bd-highlight">
                    <div className="me-auto p-0 bd-highlight">
                        <h5 className="subtitle skin">{t("searchCustomers")}</h5>
                    </div>
                    <div className="p-0 bd-highlight">
                        <button className="btn btn-skin" href="" onClick={function () { return navigate("/customer"); }}>
                            <span className="desktop-only">{t("customerAdd")} </span> <i className="fa fa-plus"></i>
                        </button>
                    </div>
                </div>
            </header>


            <div style={{ width: '100%', height: '100%' }}>
                <div className="row">
                    <div className="d-flex justify-content-between">
                        <div className="offset-md-4 col-md-4 text-center">
                            <input className="form-control" id="searchCustomersInput" placeholder={t("Search")} onChange={onQuickFilterChanged} />
                        </div>
                    </div>
                </div>
                {
                    !isMobile ?
                        <div
                            id="myGrid"
                            style={{
                                height: '100%',
                                width: '100%',
                            }}
                            className="ag-theme-alpine-dark customer-search-grid"
                        >
                            <div className="ag-theme-alpine" style={{ height: sheight, width: '100%' }}>
                                <AgGridReact
                                    pagination={pagination}
                                    paginationPageSize={paginationPageSize}
                                    onGridReady={onGridReady}
                                    style={{ width: '100%', height: '100%;' }}
                                    onRowDoubleClicked={(e) => goTo(e.data.id)}
                                    rowData={content}
                                    // domLayout={'autoHeight'}
                                    overlayNoRowsTemplate={
                                        '<span style="padding: 10px;  color:#013289">' + t('noEntries') + '</span>'
                                    }
                                    gridOptions={{ suppressMenuHide: true }}
                                    columnDefs={columnDefs}
                                    defaultColDef={{
                                        flex: 1,
                                        resizable: true,
                                        sortable: true,
                                        wrapText: true,
                                        suppressMovable: true,
                                        autoHeight: true, icons: {
                                            menu: '<i style="color:white" class="fa fa-search"/>',
                                        },
                                    }}
                                >
                                </AgGridReact>
                            </div>
                        </div> :
                        <div
                            id="myGrid"
                            style={{
                                height: '100%',
                                width: '100%',
                            }}
                            className="ag-theme-alpine-dark customer-mobile-table-container"
                        >
                            <div className="ag-theme-alpine" style={{ height: sheight, width: '100%' }}>
                                <AgGridReact
                                    pagination={pagination}
                                    paginationPageSize={paginationPageSize}
                                    onGridReady={onGridReady}
                                    style={{ width: '100%', height: '100%;' }}
                                    onRowDoubleClicked={(e) => goTo(e.data.id)}
                                    rowData={content}
                                    // domLayout={'autoHeight'}
                                    overlayNoRowsTemplate={
                                        '<span style="padding: 10px;  color:#013289">' + t('noEntries') + '</span>'
                                    }
                                    rowHeight={66}
                                    columnDefs={columnMobileDefs}
                                    gridOptions={{ suppressMenuHide: true }}
                                    defaultColDef={{
                                        wrapText: false,
                                        suppressMovable: true,
                                        suppressHorizontalScroll: true,
                                        icons: {
                                            menu: '<i style="color:white" class="fa fa-search"/>',
                                        },
                                    }}
                                >

                                </AgGridReact>
                            </div>
                        </div>
                }

            </div>
        </div>
    );
}


